var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSendMessage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 35,
    height: 36,
    viewBox: "0 0 35 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M33.6188 1.91097C32.7643 1.03394 31.4996 0.707199 30.3203 1.05113L2.82199 9.0476C1.57782 9.39326 0.695955 10.3855 0.458399 11.646C0.215716 12.9289 1.0634 14.5574 2.17085 15.2384L10.769 20.523C11.6509 21.0647 12.7891 20.9288 13.5188 20.1928L23.3646 10.2858C23.8602 9.76986 24.6805 9.76986 25.1761 10.2858C25.6718 10.7845 25.6718 11.5927 25.1761 12.1086L15.3133 22.0174C14.5818 22.7517 14.4451 23.8952 14.9835 24.7826L20.237 33.4669C20.8523 34.4987 21.9119 35.0834 23.074 35.0834C23.2108 35.0834 23.3646 35.0834 23.5013 35.0662C24.8343 34.8942 25.8939 33.9828 26.287 32.6931L34.4391 5.22993C34.798 4.06056 34.4733 2.788 33.6188 1.91097Z",
    fill: "#FAC000"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSendMessage);
export default __webpack_public_path__ + "static/media/sendMessage.0112428854eda684c12bd8d47baa2c73.svg";
export { ForwardRef as ReactComponent };